import { origins } from '@chegg-wt/core/state/instrumentation/rio/clickstreamInteractions'
import { QuickActionPanelType } from '@chegg-wt/core-wa/types'

export const actionOriginsSuggestionClick = {
  [QuickActionPanelType.PARAPHRASE]: origins.proofReaderRewriteSuggestionClick,
  [QuickActionPanelType.EXPAND]: origins.proofReaderExpandSuggestionClick,
  [QuickActionPanelType.SHORTEN]: origins.proofReaderShortenSuggestionClick,
}
export const actionOriginsSelection = {
  [QuickActionPanelType.PARAPHRASE]: origins.proofReaderRewriteClick,
  [QuickActionPanelType.EXPAND]: origins.proofReaderExpandClick,
  [QuickActionPanelType.SHORTEN]: origins.proofReaderShortenClick,
}
